var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6164 8.43379L11.5664 5.38379",
    stroke: "#4EAEA5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.20917 17.4999H2.5V14.7908C2.5 14.5699 2.5875 14.3574 2.74417 14.2016L13.8558 3.0891C14.1817 2.76327 14.7092 2.76327 15.0342 3.0891L16.91 4.96493C17.2358 5.29077 17.2358 5.81827 16.91 6.14327L5.79833 17.2558C5.6425 17.4124 5.43 17.4999 5.20917 17.4999V17.4999Z",
    stroke: "#4EAEA5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPancel);
export default __webpack_public_path__ + "static/media/pancel.60b2844f.svg";
export { ForwardRef as ReactComponent };